module.exports = __webpack_public_path__ + "static/media/profile-pic.bf564b24.jpg";